import React from "react";
import { FormWizardProvider } from "./FormWizardProvider";
import FormRenderer from "./FormRenderer";
import type { FormWizardStep } from "./types";
import type { NavigationBreadcrumbItem } from "@SeemplicityDev/shared";

export const formVariantsEnum = {
  INLINE: "INLINE",
  PAGE: "PAGE",
} as const;

export type FormVariant =
  (typeof formVariantsEnum)[keyof typeof formVariantsEnum];

// Re-exported so existing consumers can keep importing `FormWizardStep` from
// `./FormWizard`; the canonical definition lives in `./types`.
export type { FormWizardStep };

export interface FormWizardProps {
  steps: FormWizardStep[];
  onCancel: () => void;
  onSubmit: (data: Record<string, any>) => void;
  isSubmitting?: boolean;
  dangerSubmit?: boolean;
  className?: string;
  type?: FormVariant;
  originLink?: string;
  originName?: string;
  wizardName?: string;
  wizardData?: Record<string, any>;
  isValidated?: boolean;
  withSummary?: boolean;
  submitLabel?: string;
  breadcrumbs?: NavigationBreadcrumbItem[];
}

const FormWizard: React.FC<FormWizardProps> = ({
  steps,
  onCancel,
  onSubmit,
  isSubmitting,
  dangerSubmit,
  className = "",
  type = formVariantsEnum.INLINE,
  originLink = undefined,
  originName,
  wizardName = "",
  wizardData,
  isValidated = true,
  withSummary = false,
  submitLabel,
  breadcrumbs,
}) => {
  return (
    <FormWizardProvider>
      <FormRenderer
        steps={steps}
        onCancel={onCancel}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        dangerSubmit={dangerSubmit}
        submitLabel={submitLabel}
        className={className}
        type={type}
        originLink={originLink}
        originName={originName}
        wizardName={wizardName}
        isValidated={isValidated}
        wizardData={wizardData}
        withSummary={withSummary}
        breadcrumbs={breadcrumbs}
      />
    </FormWizardProvider>
  );
};

export default FormWizard;
